/* `redesign` solo cambia el color de RECHAZADO: el rediseño lo pasó a rojo, pero los sellers
   que siguen con la interfaz anterior tienen que verlo del color de siempre. Lo pasan en true
   únicamente las vistas del rediseño (ver REDESIGN_SELLERS en @/utils/redesignSellers). */
export const StatusColor = (status : string, redesign = false) => {
  switch (status) {
    case 'COTIZADO':
      return '#e08fff'
    case 'APROBADO':
      return '#fe7070'
    case 'NO APROBADO':
      return '#fe7070'
    case 'VALIDADO':
      return '#fc9432'
    case 'FIRMADO':
      return '#54c45e'
    case 'ENTREGADO':
      return '#6db1ff'
    case 'RETIRADO REUSE':
      return '#82755b'
    case 'RECHAZADO':
      return redesign ? '#ef4444' : '#00c2a8'
    case 'CUSTODIA':
      return '#AAD500'
    case 'EN BODEGA':
      return '#7b3800'
    default:
      return 'inerhit'
  }
}
